"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPreferenceSchema = exports.NotificationSchema = exports.MetadataSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.MetadataSchema = zod_1.z.object({
    notificationChannels: zod_1.z.array(_1.NotificationChannelSchema).optional(),
});
exports.NotificationSchema = __1.BaseSchema.extend({
    notificationType: zod_1.z.nativeEnum(__1.ENotificationTypes),
    notificationVersion: __1.ShortStringSchema,
    notificationData: zod_1.z.record(zod_1.z.unknown()).optional(),
    content: __1.ShortStringSchema.optional(),
    uri: __1.LongStringSchema.url().optional(),
    readStatus: zod_1.z.nativeEnum(__1.EReadStatus).optional(),
    fullyReadAt: zod_1.z.coerce.date().optional(),
    metadata: exports.MetadataSchema.optional(),
});
exports.NotificationPreferenceSchema = zod_1.z.object({
    notificationType: zod_1.z.nativeEnum(__1.ENotificationTypes),
    channelsEnabled: zod_1.z.nativeEnum(__1.ENotificationChannel).array(),
    channelsAvailable: zod_1.z.nativeEnum(__1.ENotificationChannel).array(),
});
//# sourceMappingURL=notification.js.map